import { Store } from './store';

/**
 * Hash tabanlı router. Statik servis (nginx) altında path bağımsız çalışır.
 * Rotalar: #/login, #/devices, #/devices/:serial, #/brands, #/users, #/wg, #/settings
 */
export type ScreenName = 'login' | 'devices' | 'device-detail' | 'brands' | 'scripts' | 'users' | 'wg' | 'settings';

export interface Route {
  screen: ScreenName;
  /** device-detail için seri no */
  param?: string;
}

function parse(hash: string): Route {
  const path = hash.replace(/^#\/?/, '');
  const [head, param] = path.split('/');
  switch (head) {
    case 'login':
      return { screen: 'login' };
    case 'devices':
      return param ? { screen: 'device-detail', param: decodeURIComponent(param) } : { screen: 'devices' };
    case 'brands':
      return { screen: 'brands' };
    case 'scripts':
      return { screen: 'scripts' };
    case 'users':
      return { screen: 'users' };
    case 'wg':
      return { screen: 'wg' };
    case 'settings':
      return { screen: 'settings' };
    default:
      return { screen: 'devices' };
  }
}

export const route = new Store<Route>(parse(location.hash));

window.addEventListener('hashchange', () => route.set(parse(location.hash)));

export function navigate(path: string): void {
  const next = path.startsWith('#') ? path : `#/${path.replace(/^\//, '')}`;
  if (location.hash === next) route.set(parse(next));
  else location.hash = next;
}

export function deviceDetailPath(serial: string): string {
  return `#/devices/${encodeURIComponent(serial)}`;
}
